import Cookies, { CookieAttributes } from 'js-cookie';

export enum CookieKey {
  APP_DOWNLOAD_BANNER = 'mrt-app-download-banner',
  APP_INSTALL_BANNER = 'mrt-app-install-banner',
  MRT_ACCESS_TOKEN = 'mrt_access_token',
  API_ACCESS_TOKEN = 'api-access-token',
  MAT_ID = 'mat_id',
  MRT_LNG = 'mrtLng',
  MRT_SESSION_ID = '_mrt_session_id',
  IE_SUPPORT_GUIDE_POPUP = 'mrt_ie_support_guide_popup',
  INF_GL = 'inf_gl',
  GUIDE_ACCESS_TOKEN = 'mrtg_at',
  IS_GUIDE_APP = 'is_guide_app',
  APP_DOWN_BANNER = 'app_down_banner',
  TOP_LINE_BANNER = 'top_line_banner',
}

type Key = CookieKey | string;

class CookieManager {
  static get(key: Key) {
    return Cookies.get(key);
  }

  static getJSON(key: Key) {
    return Cookies.getJSON(key);
  }

  static set(key: Key, value: string | Record<string, unknown>, options?: CookieAttributes) {
    return Cookies.set(key, value, options);
  }

  static remove(key: Key, options?: CookieAttributes) {
    Cookies.remove(key, options);
  }
}

export default CookieManager;
